import React, { useState } from 'react';
import Module2Card from '../Module2Card/Module2Card';
import Module3Card from '../Module3Card/Module3Card';
import Modal from '../Modal/Modal';
import VMBypass from '../VMBypass/VMBypass';
import ServerStreaming from '../ServerStreaming/ServerStreaming';
import './Modules.css';

const Modules = () => {
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [isModal3Open, setIsModal3Open] = useState(false);

  const openModal2 = () => {
    setIsModal2Open(true);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'none';
    }
  };

  const closeModal2 = () => {
    setIsModal2Open(false);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'flex';
    }
  };

  const openModal3 = () => {
    setIsModal3Open(true);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'none';
    }
  };

  const closeModal3 = () => {
    setIsModal3Open(false);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'flex';
    }
  };

  return (
    <>
      {/* Module 2 Section */}
      <section className="module-2-section" id="module-2">
        <div className="module-container">
          <div className="module-header">
            <h2 className="module-title">Module 2</h2>
            <p className="module-subtitle">VM-Based Protection</p>
          </div>

          <Module2Card
            onClick={openModal2}
            particlesCount={400}
            particlesOpacity={0.7}
            particlesSway={0.6}
          />
        </div>
      </section>

      {/* Module 3 Section */}
      <section className="module-3-section" id="module-3">
        <div className="module-container">
          <div className="module-header">
            <h2 className="module-title">Module 3</h2>
            <p className="module-subtitle">Server Streaming Solution</p>
          </div>

          <Module3Card
            onClick={openModal3}
            particlesCount={350}
            particlesOpacity={0.65}
            particlesSway={0.55}
          />
        </div>
      </section>

      <Modal isOpen={isModal2Open} onClose={closeModal2}>
        <VMBypass />
      </Modal>

      <Modal isOpen={isModal3Open} onClose={closeModal3}>
        <ServerStreaming />
      </Modal>
    </>
  );
};

export default Modules;
